import { Component, inject } from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-workflow-fse-plus-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './workflow-fse-plus.page.html',
  styleUrls: ['./workflow-fse-plus.page.scss'],
})
export class WorkflowFsePlusPage {
  readonly cdn = inject(CDN_URL);
}
